<ts-pipeline-step-editor
  [tasks]="data.pipelineTasks"
  [tasksFromOtherSteps]="data.tasksFromOtherSteps"
  [isCloud]="data.isCloud"
  [insideMethodType]="data.insideMethodType"
  (submitted)="close($event)"
>
</ts-pipeline-step-editor>
